import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { NavService } from './nav-service';
import { PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class SeancesNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition = this.makeNavigatorWithParam<number>(EparcoursPath.root.SEANCES, EparcoursPath.seances.EDITION);
  creation = this.makeNavigatorWithParam<number>(EparcoursPath.root.SEANCES, EparcoursPath.seances.CREATION);
  saisieAbsencesSessions = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.LISTE_SEANCES,
    EparcoursPath.seances.SAISIE_ABSENCES,
    PARAM_TOKEN
  );
  saisieAbsencesParcours = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.LISTE_SEANCES,
    EparcoursPath.seances.SAISIE_ABSENCES,
    PARAM_TOKEN
  );
}
